import dayjs from "dayjs";
import utcPlugin from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function isWithinStoreHours(timeSlots, timezone) {
  if (!timeSlots?.length || !timezone) return true;
  const now = dayjs().tz(timezone);
  const today = timeSlots.find((slot) => slot.day === DAYS[now.day()]);
  if (!today) return false;
  const time = now.format("HH:mm");
  return [
    ...today.morning_slots,
    ...today.afternoon_slots,
    ...today.evening_slots,
  ].some((slot) => slot.start_time <= time && time < slot.end_time);
}

export default function storeStatus(store, bizInfo) {
  if (store) {
    if (
      (!store.opening_time || !store.closing_time) &&
      (!store.temporarily_closed || !store.closing_day)
    ) {
      if (store.closing_day || store.temporarily_closed) {
        return {
          closed: true,
          futureOrders: false,
          title: "Store Closed",
          message: "Store is closed for the day",
        };
      } else {
        return {
          closed: true,
          futureOrders: false,
          title: "Error",
          message: "Store timings are not configured",
        };
      }
    }
  }

  let message = "";
  let title = "";
  let {
    enabled_for_ordering,
    temporarily_closed,
    closing_day,
    closed,
    close_msg,
  } = store;

  if (
    temporarily_closed ||
    closing_day ||
    closed ||
    (enabled_for_ordering !== undefined && !enabled_for_ordering)
  ) {
    if (
      store.closing_day ||
      (enabled_for_ordering !== undefined && !enabled_for_ordering)
    ) {
      if (!bizInfo) {
        return;
      }
      title = "Store Closed";
      message =
        bizInfo.msg_nearest_store_closed ||
        close_msg ||
        "Store is closed for the day";
    } else {
      title = "Temporarily closed!";
      message =
        bizInfo.msg_store_closed_temporary || "Store is temporarily closed";
    }
    return {
      closed: true,
      futureOrders: false,
      title: title,
      message: message,
    };
  }

  return {
    closed: false,
    futureOrders: true,
    title: title,
    message: message,
  };
}
